import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Home } from 'lucide-react';

export default function Gracias() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;

    // Disparar evento de conversión "Purchase" de Facebook (si el pixel está cargado)
    if (window.fbq) {
      const value = parseFloat(searchParams.get('value'));
      const currency = searchParams.get('currency') || 'USD';
      const payload = { currency };
      if (!isNaN(value) && value > 0) payload.value = value;
      window.fbq('track', 'Purchase', payload);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-6" data-testid="gracias-page">
      <div className="w-full max-w-lg bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-10 border border-slate-100 dark:border-white/5 text-center animate-in fade-in zoom-in-95 duration-500">
        <div className="w-24 h-24 bg-emerald-100 dark:bg-emerald-950/40 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-14 h-14 text-emerald-600" />
        </div>
        <h1 className="text-4xl font-black uppercase italic tracking-tighter mb-3 text-emerald-600" data-testid="gracias-title">
          ¡Gracias por tu compra!
        </h1>
        <p className="text-base text-muted-foreground mb-2">
          Tu pago fue procesado exitosamente y tus boletos ya están registrados.
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          ¡Mucha suerte en el sorteo! 🍀
        </p>

        <button
          onClick={() => navigate('/usuario?tab=boletos')}
          className="w-full h-12 bg-[#0070ba] hover:bg-[#003087] text-white font-black uppercase text-xs tracking-widest rounded-xl flex items-center justify-center gap-2 transition-colors mb-3"
          data-testid="gracias-ver-boletos-btn"
        >
          Ver mis boletos <ArrowRight className="w-4 h-4" />
        </button>
        <button
          onClick={() => navigate('/')}
          className="w-full h-12 border border-slate-200 dark:border-white/10 hover:bg-slate-50 dark:hover:bg-white/5 font-black uppercase text-xs tracking-widest rounded-xl flex items-center justify-center gap-2 transition-colors"
          data-testid="gracias-inicio-btn"
        >
          <Home className="w-4 h-4" /> Volver al inicio
        </button>
      </div>
    </div>
  );
}
